import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO,
} from '../../../helpers/EventEmitter'
import { COMPONENTS } from '../../../routers/constants'
import { TextLink } from '../../html/TextLink'
import { Element } from '../../html/element'
import { Switch } from '../../html/switch'
import { ALERT_STATUS_ID } from './constant'
import { changeSettings, selectSettings } from './store/slice'

export const AlertFromPortfolios = () => {
  const dispatch = useDispatch()
  const portfolios = useSelector(selectSettings('portfolios')) || []

  const checked = portfolios.some(
    (item) => item.alertStatusId === ALERT_STATUS_ID.ON,
  )

  const onChange = (isCheck) => {
    dispatch(
      changeSettings({
        portfolios: portfolios.map((item) => ({
          ...item,
          alertStatusId: isCheck ? ALERT_STATUS_ID.ON : ALERT_STATUS_ID.OFF,
        })),
      }),
    )
  }

  const openManagePortfolios = () => {
    EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, false)
    EventEmitter.dispatch(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, true)
  }

  return (
    <div className="dFlex">
      <div>
        <Switch checked={checked} onChange={onChange} title={<>&nbsp;</>} />
      </div>

      <div>
        <Element className="fw600" style={{ color: '#191D25' }}>
          <Translate value="common.popup.followAlert.ALERT_FROM_PORTFOLIO_TITLE" />
        </Element>
        <Element className="mt1" style={{ color: '#3A414B' }}>
          <div className="dFlex gap1">
            <div>&#8226;</div>
            <div>
              <Translate value="common.popup.followAlert.ALERT_FROM_PORTFOLIO_NOTE_1" />
            </div>
          </div>
          <div className="dFlex gap1 mt1">
            <div>&#8226;</div>
            <div>
              <TextLink
                id="ALERT_FROM_PORTFOLIO_LINK"
                value="common.popup.followAlert.ALERT_FROM_PORTFOLIO_NOTE_2"
                labelLink="common.popup.followAlert.CLICK_HERE"
                onClick={openManagePortfolios}
                isTextDecoration={false}
              />
            </div>
          </div>
          <div className="dFlex gap1 mt1">
            <div>&#8226;</div>
            <div>
              <TextLink
                value="common.popup.followAlert.ALERT_FROM_PORTFOLIO_NOTE_3"
                labelLink="common.popup.followAlert.CLICK_HERE"
                url={
                  COMPONENTS.library.components.savedPortfolios.components
                    .savedPortfolio.route
                }
                isTextDecoration={false}
              />
            </div>
          </div>
        </Element>
      </div>
    </div>
  )
}
